import React from 'react';
import { PropTypes } from 'prop-types';
import SelectInput from '../form/controls/SelectInput';
import RadioButtonGroup from '../form/controls/RadioButtonGroup';
import CommonDataService from '../../services/CommonDataService';

const selectStyle = {
  width: "33%",
  float: "left",
  margin: `15px 0`
}

class LanguageForm extends React.Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleAdd = this.handleAdd.bind(this);

    this.state = {
      languages: [],
      language: null,
      proficiencyLevel: 1,
      selected: props.selectedLanguages,
      levels: [{ id: 1, name: "1" }, { id: 2, name: "2" }, { id: 3, name: "3" }]
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selectedLanguages) {
      this.setState({ selected: nextProps.selectedLanguages });
    }
  }

  componentDidMount() {
    CommonDataService
      .getLanguages()
      .then(result => {
        this.setState({ languages: result });
      });
  }

  handleChange(statePropertyName, value) {
    if (statePropertyName && value) {
      this.setState({ [statePropertyName]: value });
    }
  }

  handleAdd() {

    if (this.state.language && this.state.language.id > 0) {

      const currentState = this.state;
      const { proficiencyLevel } = currentState;

      if (this.props.onCreate) {
        this.props.onCreate({ proficiencyLevel, ...currentState.language });
      }

      currentState.language = null;
      this.setState(Object.assign({}, currentState));
    }
  }

  render() {

    const languages = this.state.languages.filter(x => this.state.selected.findIndex(s => s.id == x.id) < 0);

    return (
      <div className="add-languages">
        <div style={selectStyle}>
          <SelectInput
            name="language"
            value={this.state.language}
            options={languages}
            onChange={this.handleChange}
            multi={false}
            placeholder="Select" />
        </div>
        <div className="level">
          <RadioButtonGroup
            name="proficiencyLevel"
            options={this.state.levels}
            selected={this.state.proficiencyLevel}
            onChange={this.handleChange} />
        </div>
        <button className="add" type="button" onClick={this.handleAdd}>Add</button>
      </div>
    );
  }
}

LanguageForm.defaultProps = {
  selectedLanguages: []
}

LanguageForm.propTypes = {
  onCreate: PropTypes.func,
  selectedLanguages: PropTypes.array
}

export default LanguageForm;



// WEBPACK FOOTER //
// ./src/components/users/LanguageForm.js